import React from 'react'
import Honeybadger from 'honeybadger-js'

// GraphQL
import { useMutation } from '@apollo/client'
import mutation from './mutation.graphql'

const withMutation = WrappedComponent => {
  return props => {
    const {
      roomMeeting, // via graphql query
      notify, // via redux actions
      setJoinUrl, // via withState
      setErrorMessage, // via redux actions
      setModal // via redux actions
    } = props

    // TODO: use shared mutation error handling?
    const handleMutationError = error => {
      setModal({ open: false })
      notify({
        variant: 'error',
        autoHide: false,
        message: "Oops, couldn't join. Please try again or refresh."
      })
      Honeybadger.notify(error, {
        name: 'CreateJoinRoomUrlError',
        context: { roomMeeting }
      })
    }

    const handleMutationCompleted = data => {
      // when data is returned:
      if (data && data.createJoinRoomUrl) {
        // display any mutation errors
        if (data.createJoinRoomUrl.errors.length > 0) {
          const message = data.createJoinRoomUrl.errors
            .map(error => error.message)
            .join(', ')

          setModal({ open: false })
          setErrorMessage(message)
        } else {
          setJoinUrl(data.createJoinRoomUrl.joinUrl)
        }
      }
    }

    // setup GraphQL mutation
    const [createJoinRoomUrl, { loading }] = useMutation(mutation, {
      onCompleted: handleMutationCompleted,
      onError: handleMutationError
    })

    return (
      <WrappedComponent
        loading={loading}
        createJoinRoomUrl={createJoinRoomUrl}
        {...props}
      />
    )
  }
}

export default withMutation
